(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('SidebarCampaignPartBuilderController', Controller);

    Controller.$inject = ['$scope', '$state', 'surveyCampaignService', 'campaign', 'part', 'questionTypes', 'visualComponentTypes'];

    function Controller($scope, $state, surveyCampaignService, campaign, part, questionTypes, visualComponentTypes) {
        $scope.questionTypes = questionTypes;
        $scope.visualComponentTypes = visualComponentTypes;

        $scope.addVisualComponent = function (visualComponentType) {
            var componentToAdd = {
                TitleEN: 'Page Break',
                VisualComponentTypeID: visualComponentType.VisualComponentTypeID,
            };

            surveyCampaignService
                .createVisualComponent(campaign.SlugObject, part.CampaignPartID, componentToAdd)
                .then(function () {
                    $state.go('survey.campaign.slug.part.builder', {}, { reload: true, location: 'replace' });
                })
        };
    }
})();